<template>
    <v-card width="100%" height="100%" class="d-flex flex-column mt-4" color="grey lighten-5">
        <DiagramToolbar
            :impositions="impositions"
            :task="task"
            :job-status="jobStatus"
            :is-job-reprinted="isJobReprinted"
            :actions="diagramActions"
        />

        <v-divider />

        <v-container fluid class="pa-0 flex-grow-1">
            <DiagramPreview
                :model="diagramModel"
                :is-job-editable="isJobEditable"
                :validations="validations"
                @selection-changed="getCurrentImpositionAndTask"
                @delete-task="deleteTask"
                @object-double-clicked="showTaskParametersDialog"
                @get-available-processes-to-add="showProcessesAvailableToAddDialog"
                @show-shipping-orders="showShipmentsOrdersDialog"
                @diagram-actions="setActions"
            />
        </v-container>
    </v-card>
</template>

<script>
import { appConfig } from '@/config'
import DiagramPreview from './DiagramPreview'
import DiagramToolbar from './DiagramToolbar'
import { EventBus } from '@/utils/eventBus'

export default {
    name: 'Diagram',
    components: { DiagramPreview, DiagramToolbar },
    props: {
        jobStatus: {
            type: Object,
            default: null
        },
        impositions: {
            type: Array,
            default: null
        },
        isJobEditable: {
            type: Boolean
        },
        isJobReprinted: {
            type: Boolean
        },
        validations: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            diagramModel: {
                nodeDataArray: [],
                linkDataArray: []
            },
            diagramActions: null,
            imposition: {},
            task: {},
            plateTypes: []
        }
    },
    computed: {
        isPrintTask() {
            return this.task.processId === appConfig.common.processes.printTaskId
        }
    },
    created() {
        EventBus.$on('parseDiagramSchema', payload => {
            this.parseSchema(payload)
        })
        EventBus.$on('changeDiagramView', () => {
            this.task = {}
        }),
        EventBus.$on('getCurrentImpositionAndTask', (id) => {
            this.getCurrentImpositionAndTask(id)
        })
    },
    destroyed() {
        EventBus.$off()
    },
    methods: {
        parseSchema(data) {
            this.diagramModel = {
                nodeDataArray: [],
                linkDataArray: []
            }

            data.tasks.forEach(task => {
                const taskId = task.id
                const imposition = data.impositions.find(imposition => {
                    return imposition.impositionTask.some(task => task.id === taskId)
                })

                const taskData = {
                    key: taskId,
                    taskName: task.process.name,
                    bruttoAmount: task.bruttoAmount,
                    nettoAmount: task.nettoAmount,
                    impositionTaskOrderComponents: task.impositionTaskOrderComponents,
                    machine: task.machine ? task.machine.name : null,
                    status: task.status,
                    processId: task.processId,
                    allowNextProcess: task.process.allowNextProcess,
                    allowPreviousProcess: task.process.allowPreviousProcess,
                    isDeletable: task.process.isDeletable,
                    impositionOrdinalNumber: task.impositionOrdinalNumber,
                    interlacingA: imposition.interlacingA,
                    interlacingB: imposition.interlacingB,
                    manyImpositions: task.manyImpositions,
                    hasDescription: task.description !== null
                }

                this.diagramModel.nodeDataArray.push(taskData)

                if (task.previousTaskIdsList.length > 0) {
                    task.previousTaskIdsList.forEach(id => {
                        this.diagramModel.linkDataArray.push({
                            from: id,
                            to: taskId
                        })
                    })
                }

                if (task.processId === 43) task.machine ? this.plateTypes = JSON.parse(JSON.stringify(task.machine.plateTypeRead)) : []
            })

            EventBus.$emit('updateDiagram', this.diagramModel)
        },
        getCurrentImpositionAndTask(id) {
            if (typeof id === 'undefined') {
                this.imposition = {}
                this.task = {}
            } else {
                this.imposition = this.impositions.find(imposition => {
                    return imposition.impositionTask.find(item => {
                        if (item.id === id) this.task = item

                        return item.id === id
                    })
                })
            }

            this.$emit('get-current-imposition-and-task', {
                imposition: this.imposition,
                task: this.task,
                plateTypes: this.plateTypes
            })
        },
        showTaskParametersDialog() {
            this.isPrintTask ? EventBus.$emit('showImpositionParametersDialog') : EventBus.$emit('showTaskParametersDialog')
        },
        showProcessesAvailableToAddDialog(data) {
            EventBus.$emit('showProcessesAvailableToAddDialog', data)
        },
        showShipmentsOrdersDialog() {
            EventBus.$emit('showShipmentsOrdersDialog')
        },
        deleteTask() {
            EventBus.$emit('showConfirmDeleteTaskDialog')
        },
        setActions(data) {
            this.diagramActions = data
        }
    }
}
</script>